import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "opacity-0 group-hover:opacity-50 transition-opacity duration-100 ease absolute top-1/2 transform -translate-y-1/2 left-0 text-lg cursor-move drag-handle material-icons-outlined"
}
const _hoisted_2 = { class: "flex flex-col items-start" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = {
  style: {"line-height":"0.95"},
  class: "mb-2 hover:text-primary hover:underline"
}
const _hoisted_5 = { class: "-mt-2 flex flex-wrap ml-0.5" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm mr-2"
}
const _hoisted_7 = {
  key: 1,
  class: "text-sm text-muted",
  style: {"margin-right":"3px"}
}
const _hoisted_8 = { class: "md:mx-12 md:px-1 flex flex-col" }
const _hoisted_9 = { class: "mt-2 flex flex-col space-y-1" }
const _hoisted_10 = { class: "flex flex-wrap items-end" }
const _hoisted_11 = { class: "text-base" }
const _hoisted_12 = { class: "group-hover:opacity-100 transition-opacity duration-100 ease opacity-50 ml-auto flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "text-muted mr-4"
}
const _hoisted_14 = {
  key: 0,
  class: "flex items-center space-x-1 text-sm"
}
const _hoisted_15 = { class: "md:block hidden" }
const _hoisted_16 = { class: "block md:hidden" }
const _hoisted_17 = {
  style: {"width":"20px","fill":"currentColor"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", { d: "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "md:block hidden"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " edit ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " delete ", -1)
const _hoisted_23 = {
  key: 1,
  class: "mt-4 hidden-in-dragging-element md:mx-12 md:px-0.5"
}
const _hoisted_24 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_CourseTreeNode = _resolveComponent("CourseTreeNode")!
  const _component_CourseTreeNodeCommentSection = _resolveComponent("CourseTreeNodeCommentSection")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'bg-light': _ctx.node.state === _ctx.AnnouncementNodeState.DRAFT }, "group card card-border card-hoverable hover-shadow-elevation hover:border-transparent relative"])
  }, [
    (_ctx.isDraggable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " drag_indicator "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex rounded-full mr-3", {
						'bg-gray-200': _ctx.node.state === _ctx.AnnouncementNodeState.DRAFT,
						'bg-primary  bg-opacity-15': _ctx.node.state === _ctx.AnnouncementNodeState.PUBLISHED,
					}]),
          style: {"min-width":"2.5rem","max-width":"2.5rem","min-height":"2.5rem","max-height":"2.5rem"}
        }, [
          _createElementVNode("span", {
            style: {"font-size":"28px !important"},
            class: _normalizeClass([{
							'text-gray-500': _ctx.node.state === _ctx.AnnouncementNodeState.DRAFT,
							'text-primary': _ctx.node.state === _ctx.AnnouncementNodeState.PUBLISHED,
						}, "m-auto material-icons-outlined"])
          }, "campaign", 2)
        ], 2),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: { name: 'CourseTreeNodeDetailDispatcher', params: { nodeId: _ctx.node.id } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("course_tree.announcement_title")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.node.creator)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.node.creator.full_name), 1))
              : _createCommentVNode("", true),
            (_ctx.updatedOnDifferentDay)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("misc.updated_on")), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_Timestamp, {
              "date-only": true,
              class: "text-sm text-muted",
              value: _ctx.node.modified
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ProcessedTextFragment, {
              class: "truncated-in-dragging-element text-muted",
              value: _ctx.bodyPreview
            }, null, 8, ["value"]),
            (_ctx.isTruncated)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 0,
                  size: 'xs',
                  class: "-ml-1",
                  variant: 'primary-borderless',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowMore()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("misc.show_more")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          false
            ? (_openBlock(), _createBlock(_component_Avatar, {
                key: 0,
                user: _ctx.node.creator,
                class: "ml-auto"
              }, null, 8, ["user"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.node.state === _ctx.AnnouncementNodeState.DRAFT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.node.schedule_publish_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("course_tree.scheduled_for")), 1),
                    _createElementVNode("p", _hoisted_16, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                    ]),
                    _createVNode(_component_Timestamp, {
                      value: _ctx.node.schedule_publish_at
                    }, null, 8, ["value"])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("course_tree.draft")), 1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.canEdit)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 1,
              onClick: _ctx.onEdit,
              variant: 'icon',
              outline: true,
              class: "icon-btn-primary",
              tooltip: _ctx.$t('misc.edit')
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["onClick", "tooltip"]))
          : _createCommentVNode("", true),
        (_ctx.canEdit)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 2,
              class: "mr-4",
              onClick: _ctx.onDelete,
              variant: 'icon',
              outline: true,
              tooltip: _ctx.$t('misc.delete')
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["onClick", "tooltip"]))
          : _createCommentVNode("", true),
        _createVNode(_component_CopyToClipboard, {
          "icon-only": true,
          tooltip: _ctx.$t('exercise_solution.share'),
          value: _ctx.permalink
        }, null, 8, ["tooltip", "value"])
      ])
    ]),
    (_ctx.children.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "",
                key: child.id
              }, [
                _createVNode(_component_CourseTreeNode, _mergeProps(_ctx.$props, {
                  node: child,
                  isDraggable: false,
                  onDeleteNode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deleteNode', $event)))
                }), null, 16, ["node"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CourseTreeNodeCommentSection, {
      class: "w-full md:ml- mt-6 hidden-in-dragging-element",
      nodeId: _ctx.node.id
    }, null, 8, ["nodeId"])
  ], 2))
}